const clubHandlersList = (state = null, action) => {
  if (action.type === "SET_CLUB_HANDLERS_LIST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CLUB_HANDLERS_LIST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default clubHandlersList;
